import { RoomProviderConnectRoute } from "./RoomProviderConnectRoute";

export const ROOM_ROUTES = {
  callback: {
    key: "room-connect-callback",
    element: <RoomProviderConnectRoute />,
    path: "/rooms/callback/:provider"
  }
};
